import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, LegalConsentGate } from '../pages/Auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return null; // No loader needed for fast auth check
  }

  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the protected content behind the legal-consent gate
  return <LegalConsentGate>{children}</LegalConsentGate>;
};
